<template>

  <div v-if="$store.getters.user">Erfolgreich authentifiziert</div>
  <div v-else-if="authFailed">Zugriff nicht möglich - bitte den Plan erneut über die App öffnen.</div>

</template>

<script>

  import axios from 'axios'
  axios.defaults.withCredentials = true

  export default {
    name: 'ExternalPlanAuth',
    data () {
      return {
        authFailed: false,
      }
    },
    async created () {

      console.log('ExternalPlanAuth created')

      // ab hier nie mehr Login-Seite oder Session-Expired-Modal zeigen - dieser Flow
      // authentifiziert sich über externalAuthBootstrap, nicht über den normalen Login.
      this.$store.commit('setPlanansichtApp', true)
      this.$store.commit('setSessionExpired', false)

      if (!this.$route.params.customer_id) {
        console.log('ExternalPlanAuth: customer_id fehlt', this.$route.params)
        this.authFailed = true
        return
      }

      // Sprache (optional)
      const lang = this.$route.params.lang
      if (lang) {
        this.setLang(lang)
      }

      // Die Server-Session wurde bereits durch /plan/externalAuthBootstrap aufgebaut —
      // hier wird nur noch der Vue-Store mit User, Rolle und Customer befüllt.
      const url = process.env.VUE_APP_SERVER_URL + '/plan/getCurrentPlanUser'
      try {

        const response = await axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
          },
        })

        if (!response?.data?.role) {
          console.log('ExternalPlanAuth: keine Rolle in Response', response?.data)
          this.authFailed = true
          return
        }

        this.$store.commit('setUserRole', response.data.role)
        this.$store.commit('setUser', response.data.user)
        this.$store.commit('setAnzahlCustomer', 1)
        this.$store.commit('setPlanansichtApp', true)

        const splitted = this.$route.params.customer_id.split('_')
        const customer = {
          cardcode: splitted[1],
          biotechCountry: {
            name: splitted[0],
          },
        }
        this.setCustomerAndUserRights(customer)

        if (!this.$route.params.plan_id) {
          this.$router.push('/Plan')
        } else {
          const params = {
            id: this.$route.params.plan_id,
          }
          if (this.$route.params.position_id) {
            params.position_id = this.$route.params.position_id
          }
          this.$router.push({
            name: 'Plan',
            params: params,
          })
        }

      } catch (error) {
        console.log('ExternalPlanAuth: getCurrentPlanUser error', error)
        this.authFailed = true
      }

    },
    methods: {

      setLang: function (lang) {

        this.$i18n.locale = lang

        const url = process.env.VUE_APP_SERVER_URL + '/app/setLang'
        const params = {
          lang: lang,
        }
        axios.get(url, {
          params: params,
          withCredentials: true,
        })

      },

    },

  }

</script>
